import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { AnchorComponent, ButtonComponent } from "../elements";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getAlumno, updateAlumno } from "../../api/giras.ts";
import { getGeneros, tipoAlimentacion, tipoSangre, tallaPolera } from "../../api/mantenedores.ts";
import Swal from 'sweetalert2';

export default function MisGirasTableComponent({ thead, data, informacionAceptada }) {

    const { t } = useContext(TranslatorContext)

    const [alertModal, setAlertModal] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [alumnoIncompleto, setAlumnoIncompleto] = useState(null);
    const [editData, setEditData] = useState({});
    const [rutInputValue, setRutInputValue] = useState("");
    const [generos, setGeneros] = useState([]);
    const [tipoAlimentacionData, setTipoAlimentacionData] = useState([]);
    const [tipoSangreData, setTipoSangreData] = useState([]);
    const [tallaPoleraData, setTallaPoleraData] = useState([]);
   
    const [giras, setGiras] = useState([]);

    useEffect(() => { 
        // Validar que data existe y es un array
        if (!data || !Array.isArray(data)) {
            setGiras([]);
            return;
        }
        
        setGiras(data);
        
        // Buscar el primer pasajero con información incompleta
        const pasajeroIncompleto = data.find(item => item.informacion === null);
        
        if (pasajeroIncompleto) {
            setAlumnoIncompleto(pasajeroIncompleto);
            loadAlumnoData(pasajeroIncompleto.alu_id);
            if(informacionAceptada === false) {
                setShowInfoModal(false);
            }else {
                setShowInfoModal(true); 
            } 
            
        }
    }, [data]);

    // Función para cargar datos del alumno y mantenedores
    const loadAlumnoData = async (alumnoId) => {
        try {
            // Cargar datos del alumno
            const alumnoData = await getAlumno(alumnoId);
            setEditData({
                ...alumnoData,
                alu_fecha_vencimiento_documento: alumnoData?.alu_fecha_vencimiento_documento 
                    ? formatDateForInput(alumnoData.alu_fecha_vencimiento_documento) 
                    : ""
            } || {});
            setRutInputValue(alumnoData?.alu_rut ? (alumnoData?.alu_dv ? `${alumnoData.alu_rut}-${alumnoData.alu_dv}` : `${alumnoData.alu_rut}`) : "");

            // Cargar mantenedores
            const [generosData, tipoAlimentacionResp, tipoSangreResp, tallaPoleraResp] = await Promise.all([
                getGeneros(),
                tipoAlimentacion(),
                tipoSangre(),
                tallaPolera()
            ]);

            setGeneros(generosData.data);
            setTipoAlimentacionData(tipoAlimentacionResp.data);
            setTipoSangreData(tipoSangreResp.data);
            setTallaPoleraData(tallaPoleraResp.data);
        } catch (error) {
            console.error("Error cargando datos del alumno:", error);
        }
    };

    // Función para formatear fecha de DD/MM/YYYY a YYYY-MM-DD
    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        if (dateString.includes('-')) return dateString;
        const [day, month, year] = dateString.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    // Función para formatear fecha de YYYY-MM-DD a DD/MM/YYYY
    const formatDateForSave = (dateString) => {
        if (!dateString) return "";
        if (dateString.includes('/')) return dateString;
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };

    // Función para formatear y validar RUT
    const checkRut = (rutInput) => {
        var valor = rutInput.value.replace('.','');
        valor = valor.replace('-','');
        
        const cuerpo = valor.slice(0,-1);
        const dv = valor.slice(-1).toUpperCase();
        
        rutInput.value = cuerpo + '-'+ dv;
        
        if(cuerpo.length < 7) { 
            rutInput.setCustomValidity("RUT Incompleto"); 
            return false;
        }
        
        let suma = 0;
        let multiplo = 2;
        
        for(let i=1; i<=cuerpo.length; i++) {
            const index = multiplo * valor.charAt(cuerpo.length - i);
            suma = suma + index;
            if(multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }
        }
        
        let dvEsperado = 11 - (suma % 11);
        let dvNumerico = (dv === 'K') ? 10 : parseInt(dv);
        dvNumerico = (dvNumerico === 0) ? 11 : dvNumerico;
        
        if(dvEsperado !== dvNumerico) { 
            rutInput.setCustomValidity("RUT Inválido"); 
            return false; 
        }
        
        rutInput.setCustomValidity('');
        
        setEditData({ 
            ...editData, 
            alu_rut: parseInt(cuerpo), 
            alu_dv: dv 
        });
        
        setRutInputValue(rutInput.value);
        return true;
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        if (name === "alu_nombre_social_activo" && value === "0") {
            // Si selecciona "No", limpiar el campo de Nombre Social
            setEditData({ ...editData, [name]: value, alu_nombre_social: "" });
        } else {
            setEditData({ ...editData, [name]: value });
        }
    };

    const handleSaveInfo = async () => {
        const camposRequeridos = [
            { key: "alu_nombres", label: "Nombres" },
            { key: "alu_apellidos", label: "Apellidos" },
            { key: "alu_rut", label: "RUT" },
            { key: "alu_fnacimiento", label: "Fecha de Nacimiento" },
            { key: "alu_nacionalidad", label: "Nacionalidad" },
            { key: "idgenero", label: "Género" },
            { key: "idalimentacion", label: "Tipo Alimentación" },
            { key: "idsangre", label: "Tipo Sangre" },
            { key: "idpolera", label: "Talla Polera" },
            { key: "alu_alergia", label: "Alergía" },
            { key: "alu_enfermedad", label: "Enfermedad Preexistente" },
            { key: "alu_tratamiento", label: "Tratamiento" },
            { key: "alu_tipo_documento", label: "Tipo de Documento para Viaje" },
            { key: "alu_fecha_vencimiento_documento", label: "Fecha de Vencimiento del Documento" },
            ...(editData.alu_nombre_social_activo === "1" ? [{ key: "alu_nombre_social", label: "Nombre Social" }] : [])
        ];

        const vacios = camposRequeridos.filter(campo => !editData[campo.key] || editData[campo.key].toString().trim() === "");

        if (vacios.length > 0) {
            Swal.fire({
                icon: 'warning',
                text: `Debes completar: ${vacios.map(v => v.label).join(', ')}`
            });
            return;
        }

        try {
            const result = await updateAlumno(editData);
            if (result.error === false) {
                Swal.fire({
                    icon: 'success',
                    text: 'Información del pasajero completada correctamente.'
                });
                setShowInfoModal(false);
                // Actualizar la lista de giras para reflejar el cambio
                window.location.reload();
            } else {
                Swal.fire({
                    icon: 'error',
                    text: result.msg || 'Error al actualizar la información'
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: 'Error al guardar la información'
            });
        }
    };
   

    return (
        <div className="mc-table-responsive">
            <table className="mc-table product">
                <thead className="mc-table-head primary">
                    <tr>
                       
                        {thead?.map((item, index) => (
                            <th key={ index }>{ t(item) }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body">
                    {giras && giras.length > 0 ? giras.map((item, index) => (
                            <tr key={ index }> 
                                <td>{ item.alu_nombres } </td>
                                <td> { item.alu_apellidos }</td>
                                <td>{item.alu_rut?.toLocaleString('es-CL')}-{item.alu_dv}</td>
                                <td>{ item.est_nombre } </td>
                                <td>{ item.gir_curso }</td>
                                <td>{ item.programa }</td>
                                <td>{ item.alu_nombre_social_activo === 1 ? item.alu_nombre_social : "-" }</td>
                                <td> 
                                                                                                { item.informacion !== null && item.pagos === null && <p className="mc-table-badge green">Completado</p> }

                                                                                               
                                                                                                {/* { item.pagos !== null && <OverlayTrigger placement="top" overlay={<Tooltip>Tienes pagos pendientes que deben ser realizados antes de la fecha límite </Tooltip>}>
                                                                                                <p className="mc-table-badge red" >Cuotas pendientes</p>
                                                                                                 </OverlayTrigger> } */}
                                                                                                 
                                                                                                 </td>
                                                                                           
                                                                                            
                                                                                            <td>
                                                                                                <div className="mc-table-action">
                                                                                                    <AnchorComponent to={{
                                                                                                          pathname: "/ver-mi-gira",
                                                                                                          search: "?gira="+item.gir_id+"&alumno="+item.alu_id,
                                                                                                    }} title="View" className="material-icons view"><i className='material-icons'>search</i></AnchorComponent>
                                                                                                  
                                                                                                </div>
                                                                                            </td>
                            </tr>
                    )) : (
                        <tr>
                            <td colSpan={thead?.length || 7} className="text-center">
                                No hay datos disponibles
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <Modal show={ alertModal } onHide={()=> setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>are your sure!</h3>
                    <p>Want to delete this product?</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setAlertModal(false)}>{t('close')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={()=> setAlertModal(false)}>{t('delete')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

            {/* Modal para completar información del pasajero */}
            <Modal 
                show={showInfoModal} 
                onHide={null} 
                size="xl"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header>
                        <Modal.Title>
                            <i className="material-icons">info</i>
                            Completar Información del Pasajero (Obligatorio)
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {alumnoIncompleto && (
                            <div className="mb-3">
                                <div className="alert alert-warning" role="alert">
                                    <i className="material-icons">warning</i>
                                    <strong>Información Obligatoria:</strong> Debes completar todos los datos del pasajero para continuar. 
                                    Este modal no se puede cerrar hasta que toda la información esté completa.
                                    <br ></br>
                                    Los Datos queden pendientes se pueden completar más tarde desde el perfil del pasajero.
                                </div>
                                <p><strong>Pasajero:</strong> {alumnoIncompleto.alu_nombres} {alumnoIncompleto.alu_apellidos}</p>
                                <p><strong>Gira:</strong> {alumnoIncompleto.est_nombre} - {alumnoIncompleto.gir_curso}</p>
                                <hr/>
                            </div>
                        )}
                        <Form>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nombres</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="alu_nombres"
                                            value={editData.alu_nombres || ""}
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Apellidos</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="alu_apellidos"
                                            value={editData.alu_apellidos || ""}
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>RUT</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="alu_rut_completo"
                                            value={rutInputValue}
                                            onChange={(e) => {
                                                setRutInputValue(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                if (e.target.value.length >= 8) {
                                                    checkRut(e.target);
                                                    setRutInputValue(e.target.value);
                                                } else {
                                                    e.target.setCustomValidity('');
                                                }
                                            }}
                                            placeholder="12345678-9"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Fecha de Nacimiento</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="alu_fnacimiento"
                                            value={formatDateForInput(editData.alu_fnacimiento) || ""}
                                            onChange={(e) => {
                                                const formattedDate = formatDateForSave(e.target.value);
                                                setEditData({ ...editData, alu_fnacimiento: formattedDate });
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nacionalidad</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="alu_nacionalidad"
                                            value={editData.alu_nacionalidad || ""}
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Género según CI</Form.Label>
                                        <Form.Select
                                            name="idgenero"
                                            value={editData.idgenero || ""}
                                            onChange={handleEditChange}
                                        >
                                            <option value="">Seleccionar</option>
                                            {generos?.map((g) => (
                                                <option key={g.id} value={g.id}>{g.nombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3">
                                <Form.Label>Alergía</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="alu_alergia"
                                    value={editData.alu_alergia || ""}
                                    onChange={handleEditChange}
                                />
                            </Form.Group>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo Alimentación</Form.Label>
                                        <Form.Select
                                            name="idalimentacion"
                                            value={editData.idalimentacion || ""}
                                            onChange={handleEditChange}
                                             disabled={!!editData.idalimentacion}
                                        >
                                            <option value="">Seleccionar</option>
                                            {tipoAlimentacionData.filter((a) => a.nombre !== 'Intol. Lactosa').map((a) => (
                                                <option key={a.id} value={a.id}>{a.nombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo Sangre</Form.Label>
                                        <Form.Select
                                            name="idsangre"
                                            value={editData.idsangre || ""}
                                            onChange={handleEditChange}
                                        >
                                            <option value="">Seleccionar</option>
                                            {tipoSangreData.map((s) => (
                                                <option key={s.id} value={s.id}>{s.nombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3">
                                <Form.Label>Enfermedad Pre-existente y/o Tipo de Alergia</Form.Label>
                                <Form.Control
                                    as="textarea" 
                                    rows={2}
                                    name="alu_enfermedad"
                                    value={editData.alu_enfermedad || ""}
                                    onChange={handleEditChange}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Tratamiento</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="alu_tratamiento"
                                    value={editData.alu_tratamiento || ""}
                                    onChange={handleEditChange}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Talla Polera</Form.Label>
                                <Form.Select
                                    name="idpolera"
                                    value={editData.idpolera || ""}
                                    onChange={handleEditChange}
                                    disabled={!!editData.idpolera}
                                >
                                    <option value="">Seleccionar</option>
                                    {tallaPoleraData.map((t) => (
                                        <option key={t.id} value={t.id}>{t.nombre}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    ¿Posee Nombre Social?
                                    <i 
                                        className='material-icons' 
                                        style={{ fontSize: '18px', color: '#1976d2', cursor: 'pointer' }}
                                        title="Completar solo si el alumno es menor en transición de género"
                                    >
                                        info
                                    </i> Completar solo si el alumno/a es menor en transición de género
                                </Form.Label>
                                <Form.Select
                                    name="alu_nombre_social_activo"
                                    value={editData.alu_nombre_social_activo || "0"}
                                    onChange={handleEditChange}
                                >
                                    <option value="0">No</option>
                                    <option value="1">Si</option>
                                </Form.Select>
                            </Form.Group>
                            {editData.alu_nombre_social_activo === "1" && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Nombre Social</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="alu_nombre_social"
                                        value={editData.alu_nombre_social || ""}
                                        onChange={handleEditChange}
                                        placeholder="Ingrese nombre social"
                                    />
                                </Form.Group>
                            )}
                            <hr />
                            <h6 className="mb-3"><strong>Documento para Viaje (Obligatorio)</strong></h6>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>Tipo de Documento *</strong></Form.Label>
                                        <Form.Select
                                            name="alu_tipo_documento"
                                            value={editData.alu_tipo_documento || ""}
                                            onChange={handleEditChange}
                                        >
                                            <option value="">Seleccionar...</option>
                                            <option value="Cedula de Identidad">Cédula de Identidad</option>
                                            <option value="Pasaporte">Pasaporte</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>Fecha de Vencimiento del Documento *</strong></Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="alu_fecha_vencimiento_documento"
                                            value={formatDateForInput(editData.alu_fecha_vencimiento_documento) || ""}
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSaveInfo} className="w-100">
                        Guardar Información Completa
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}